import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { JsonpModule } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import {appRoutes} from "./app.routes";
import { NavComponent } from "./common/nav/nav.component";
import { ModalPasswordComponent } from "./common/modal-password/modal-password.component";
import {UsersModule} from "./modules/users/users.module";
import {ServicesModule} from "./modules/services/services.module";
import {CleanersModule} from "./modules/cleaners/cleaners.module";
import {BillsModule} from "./modules/bills/bills.module";
import {AssignModule} from "./modules/assign/assign.module";
import {StaffModule} from "./modules/staff/staff.module";
import {SharedModule} from "./common/shared.module";
import {ExportsModule} from "./modules/exports/exports.module";
import {LoginModule} from "./modules/login/login.module";
import {AvailabilityModule} from "./modules/availability/availability.module";
import {AuthService} from "./injections/auth.service";
import {LoginService} from "./injections/login.service";
import {StatsService} from "./injections/stats.service";
import { LoaderService } from './common/loadingBar/loader.service';
import { ModalPasswordService } from './common/modal-password/modal-password.service';
import { LoaderComponent } from './common/loadingBar/loader.component';
import {LocationStrategy, HashLocationStrategy} from '@angular/common';
import {Routing} from "./app.routes";
import { NgProgressModule, NgProgressInterceptor } from 'ngx-progressbar';


@NgModule({
  declarations: [
    AppComponent, 
    NavComponent,
    LoaderComponent,
    ModalPasswordComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    JsonpModule,
    UsersModule,
    ServicesModule,
    CleanersModule,
    BillsModule,
    StaffModule,
    SharedModule,
    ExportsModule,
    LoginModule,
    AssignModule,
    AvailabilityModule,
    NgProgressModule,
    Routing
  ],
  providers: [AuthService, 
              LoaderService, 
              LoginService, 
              ModalPasswordService, 
              StatsService,
              { provide: HTTP_INTERCEPTORS, useClass: NgProgressInterceptor, multi: true }
            ],
  bootstrap: [AppComponent]
})
export class AppModule {}


// WEBPACK FOOTER //
// ./src/app/app.module.ts